import {
	MULTIMEDIA_GET_FILES,
	MULTIMEDIA_GET_FILES_SUCCESS,
	MULTIMEDIA_GET_FILES_FAILURE,
	MULTIMEDIA_CREATE_FILE,
	MULTIMEDIA_CREATE_FILE_SUCCESS,
	MULTIMEDIA_CREATE_FILE_FAILURE,
	MULTIMEDIA_SELECT_FILE,
	MULTIMEDIA_EDIT_FILE,
	MULTIMEDIA_EDIT_FILE_SUCCESS,
	MULTIMEDIA_EDIT_FILE_FAILURE,
	MULTIMEDIA_REMOVE_FILE_SUCCESS,
	MULTIMEDIA_REMOVE_FILE,
	MULTIMEDIA_REMOVE_FILE_FAILURE,
	MULTIMEDIA_UNSELECT_FILE,
	MULTIMEDIA_SELECT_FILES, MULTIMEDIA_PROPS_CHANGED
} from "./actions";
import {debug, find} from "../../utility/functions";
import config from '../../config'


export const dispatchOnMultimediaGetFiles = () => dispatch => {
	return dispatch({type: MULTIMEDIA_GET_FILES})
};

export const dispatchOnMultimediaGetFilesSuccess = (response) => dispatch => {
	return dispatch({
		type: MULTIMEDIA_GET_FILES_SUCCESS,
		files: response.data,
		pagination: response.pagination,
	})
};

export const dispatchOnMultimediaGetFilesFailure = (error) => dispatch => {
	return dispatch({type: MULTIMEDIA_GET_FILES_FAILURE})
};


export const dispatchOnMultimediaCreateFile = () => dispatch => {
	dispatch({type: MULTIMEDIA_CREATE_FILE})
};

export const dispatchOnMultimediaCreateFileSuccess = (files) => dispatch => {
	dispatch({
		type: MULTIMEDIA_CREATE_FILE_SUCCESS,
		files
	})
};

export const dispatchOnMultimediaCreateFileFailure = (error) => dispatch => {
	dispatch({type: MULTIMEDIA_CREATE_FILE_FAILURE})
};

export const dispatchOnMultimediaEditFile = () => dispatch => {
	dispatch({type: MULTIMEDIA_EDIT_FILE})
};

export const dispatchOnMultimediaEditFileSuccess = (file) => dispatch => {
	dispatch({
		type: MULTIMEDIA_EDIT_FILE_SUCCESS,
		file,
	})
};

export const dispatchOnMultimediaEditFileFailure = (error) => dispatch => {
	dispatch({type: MULTIMEDIA_EDIT_FILE_FAILURE})
};

export const dispatchOnMultimediaRemoveFile = () => dispatch => {
	dispatch({type: MULTIMEDIA_REMOVE_FILE})
};

export const dispatchOnMultimediaRemoveFileSuccess = (file) => dispatch => {
	dispatch({type: MULTIMEDIA_REMOVE_FILE_SUCCESS, file})
};

export const dispatchOnMultimediaRemoveFileFailure = (error) => dispatch => {
	dispatch({type: MULTIMEDIA_REMOVE_FILE_FAILURE})
};

export const dispatchOnMultimediaSelectFile = (file) => dispatch => {
	dispatch({type: MULTIMEDIA_SELECT_FILE, file})
};

export const dispatchOnMultimediaUnselectFile = (file) => dispatch => {
	dispatch({type: MULTIMEDIA_UNSELECT_FILE, file});
};

export const dispatchOnMultimediaReplaceFile = (file) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		selectedFiles : [file]
	});
};

export const dispatchOnMultimediaSetSelectedFile = (selectedFiles) => dispatch => {
	debug("Selected files", selectedFiles);
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		selectedFiles
	});
};

export const dispatchOnMultimediaClearSelectedFiles = () => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		selectedFiles: []
	})
};

export const dispatchOnMultimediaSelectFiles = (files) => dispatch => {
	dispatch({type: MULTIMEDIA_SELECT_FILES, files})
};

export const dispatchOnMultimediaFilterChanged = (filter) => dispatch => {
	dispatch({type: MULTIMEDIA_PROPS_CHANGED, filter})
};

export const dispatchOnMultimediaAddFileModeChanged = (adding) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		adding,
	})
};

export const dispatchOnMultimediaNameChanged = (name) => dispatch => {
	dispatch({type: MULTIMEDIA_PROPS_CHANGED, name})
};

export const dispatchOnMultimediaAuthorChanged = (author) => dispatch => {
	dispatch({type: MULTIMEDIA_PROPS_CHANGED, author})
};

export const dispatchOnMultimediaFileChanged = (file) => dispatch => {
	dispatch({type: MULTIMEDIA_PROPS_CHANGED, file})
};

export const dispatchOnMultimediaEditFileModeChanged = (editing, file, index) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		file,
		index,
		name: find(file, 'name'),
		author: find(file, 'author'),
		editing,
	})
};

export const dispatchOnMultimediaRemoveFileModeChanged = (removing, file, index) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		file,
		index,
		name: find(file, 'name'),
		author: find(file, 'author'),
		removing
	})
};

export const dispatchOnMultimediaSearchChanged = (search) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		search,
	})
};

export const dispatchOnMultimediaClearForm = () => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		names: [],
		name_all: "",
		authors: [],
		author_all: "",
		filesPicked: [],
		selectedFilePicked: 0,
	})
};




export const dispatchOnMultimediaSetNames = (names) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		names,
	})
};

export const dispatchOnMultimediaSetNameGeneral = (name_all) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		name_all,
	})
};

export const dispatchOnMultimediaSetAuthors = (authors) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		authors,
	})
};

export const dispatchOnMultimediaSetAuthorGeneral = (author_all) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		author_all,
	})
};

export const dispatchOnMultimediaSetFilesPicked = (filesPicked, names, authors) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		filesPicked,
		names,
		authors,
	})
};

export const dispatchOnMultimediaSetSelectedFilePicked = (selectedFilePicked) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		selectedFilePicked,
	})
};

export const dispatchOnMultimediaUploadedFilesWithSomeIgnored = (oldFiles, files, filesPicked, names, authors) => dispatch => {
	dispatch({
		type: MULTIMEDIA_PROPS_CHANGED,
		files: [...files, ...oldFiles],
		filesPicked,
		names,
		authors,
		uploading: false,
		selectedFilePicked: 0,
	})
};